<script setup lang="ts">
  import { onMounted } from 'vue'
  import { useI18n } from 'vue-i18n'

  import { PageTheme, useLayoutStore } from '@/stores/layout'
  import { useAuthStore } from '@/stores/auth'
  
  import { KsButton } from '@aschehoug/kloss'
  import AppFooter from '@/components/layout/DefaultFooter.vue'
  import ImageWithCaption from '@/components/common/ImageWithCaption.vue'
  import Logo from '@/components/icons/Logo.vue'
  import Typography from '@/components/common/Typography.vue'

  const { isAuthenticated, loginFeide } = useAuthStore()
  const { t: translations } = useI18n()

  const { setTheme } = useLayoutStore()
  onMounted(() => setTheme(PageTheme.FrontpagePublic))
</script>

<template>
  <main class="content-wrapper">
    <div class="text">
      <div class="text-and-login-button">
        <Logo class="logo" />

        <Typography
          variant="h1"
          class="main-text"
          :font-weight="200"
        >
          {{ translations('frontPage.digitalTeachingAid') }}
        </Typography>
        <KsButton
          v-if="!isAuthenticated"
          shape="rounded"
          variant="border"
          @click="loginFeide"
        >
          {{ translations('loginWithFeide') }}
        </KsButton>
      </div>
    </div>
    <div class="image">
      <ImageWithCaption
        src="/forside-public.webp"
        alt-text="Bilde av fagbøker"
        aria-hidden="true"
        copyright="Foto av Jmendez/istock photo, Klaus Vedfelt / Getty Images, Unsplash+ in collaboration with Getty Images, Nina Manandhar / Getty Images , gorodenkoff / istock photo"
        object-fit="cover"
      />
    </div>
  </main>
  <AppFooter class="vgs-footer" />
</template>

<style scoped lang="scss">
  $logo-height: 50px;

  .logo {
    fill: var(--color-coral-20);
    width: auto;
    height: $logo-height;

    @include vgs-media-desktop {
      position: absolute;
      top: 0;
      left: 0;
      justify-self: flex-start;
    }
  }

  .content-wrapper {
    --background-color: var(--color-blue-50);
    --text-color: var(--color-coral-20);

    min-height: 100vh;
    background-color: var(--background-color);
    color: var(--text-color);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    @include vgs-media-desktop {
      padding-bottom: $logo-height;
    }

    @include vgs-media-mobile-and-tablet {
      flex-direction: column;
      gap: 96px;
      padding: 80px 24px 128px;
    }
  }

  .text,
  .image {
    flex: 1;
  }

  .text {
    height: 100%;
  }

  .image {
    flex: 1;
    display: flex;

    @include vgs-media-desktop {
      height: 100vh;
    }
  }

  .text-and-login-button {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 40px;
    flex: 1;
    position: relative;

    @include vgs-media-desktop {
      height: 100%;
      margin: 64px 128px;
    }

    .main-text {
      line-height: 72px;
      margin: 0;

      @include vgs-media-mobile-and-tablet {
        line-height: 1.3;
      }
    }
  }

  .vgs-footer {
    margin-top: auto;
    background-color: var(--background-color);
    color: var(--text-color);

    --ks-secondary: var(--text-color);
  }

  button {
    padding: 10px 24px 10px 20px;
    color: var(--color-coral-20);

    --ks-border: var(--color-coral-20);

  }
</style>
